import {
  FeasibilityFilterCriteriaGroup,
  SurveyLookupParams,
} from '@ps/survey-utils';

export class AdvancedFiltersLookupParams {
  constructor(
    public readonly criteria: readonly FeasibilityFilterCriteriaGroup[],
    public readonly dateRange: readonly Date[] | null,
  ) {}

  public hasCriteriaOrDateRange(): boolean {
    return (
      this.criteria.some((group) => group.values.length > 0) ||
      !!this.dateRange?.length
    );
  }

  public build(): SurveyLookupParams {
    const [start, end] = this.dateRange ?? [];

    return {
      fromDate: start ?? null,
      toDate: end ?? null,
      projectManagerIds: this._idsFor('projectManager').map(Number),
      billingNumbers: this._idsFor('billingNumber'),
      templateIds: this._idsFor('template').map(Number),
      surveyIds: this._idsFor('surveyTitle').map(Number),
    };
  }

  private _idsFor(type: FeasibilityFilterCriteriaGroup['type']): string[] {
    return (
      this.criteria
        .find((group) => group.type === type)
        ?.values.map((value) => value.id) ?? []
    );
  }
}
